<app-header [user]="user()" />

<div class="www-cha-for">
  <section class="www-cha-for__con">
    <form
      [formGroup]="formGroup"
      [ngxsFormClearOnDestroy]="_isBrowser"
      [ngxsFormDebounce]="20"
      [ngxsForm]="'changeForgotPassword.form'"
      class="www-form www-cha-for__con__form"
      appInvalidControlScroll
      [appAnimate]="'fadeInLeft'"
      [speed]="'fast'"
      novalidate
    >
      <h3 class="www-cha-for__con__form__ti">Zmień hasło</h3>

      <div class="row">
        <div class="col-12">
          <div
            class="group"
            [appShowPassword]="'assets/images/icon-remove-red-eye.svg'"
            iAlt="Show password"
            [iWidth]="'19'"
            [iHeight]="'19'"
          >
            <input [appInputValidator]="f.password" [formControlName]="'password'" id="password" type="password" />
            <label for="password">Ustaw hasło</label>
          </div>
          <app-validate-message [control]="f.password" />
        </div>

        <div class="col-12">
          <div
            class="group"
            [appShowPassword]="'assets/images/icon-remove-red-eye.svg'"
            iAlt="Show password"
            [iWidth]="'19'"
            [iHeight]="'19'"
          >
            <input
              [appInputValidator]="f.repeatPassword"
              [formControlName]="'repeatPassword'"
              id="repeatPassword"
              type="password"
            />
            <label for="password">Powtórz hasło</label>
          </div>
          <app-validate-message [control]="f.repeatPassword" />
        </div>

        <div class="col-12 www-cha-for__con__form__pass-req">
          <p class="www-cha-for__con__form__pass-req__p">Hasło powinno składać się z:</p>
          <ul class="www-cha-for__con__form__pass-req__ul">
            <li>Co najmniej 8 znaków</li>
            <li>liczby</li>
            <li>znaku specjalnego</li>
            <li>wielkiej litery</li>
          </ul>
        </div>

        <div class="col-12 www-cha-for__con__form__not-rem">
          <a
            class="www-cha-for__con__form__not-rem__a"
            [routerLink]="['/' + routeSlug.LOGIN]"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'change forgotten password page',
              eventAction: 'select::go to login page',
              eventLabel: 'go to login page::' + '/' + WwwRouteSlug.LOGIN,
              event_name: 'body_button_click',
              module_name: 'go to login page',
              cta_name: 'go to login page',
              link_url: '/' + WwwRouteSlug.LOGIN,
            }"
          >
            Przejdź do logowania
          </a>
        </div>
      </div>

      <div class="row www-cha-for__btn my-3 my-md-0">
        <div class="col-12">
          <button (click)="onChangeForgotPassword()" class="www-black-btn w-100">
            <span>Zmień hasło</span>
            <span> ></span>
          </button>
        </div>
      </div>
    </form>
    <div class="www-cha-for__con__rig">
      <picture>
        <source media="(max-width:402px)" srcset="assets/images/pages/login/login-banner-mb.webp" />
        <img
          class="www-cha-for__con__rig__img h-auto"
          [priority]="true"
          alt="background"
          ngSrc="assets/images/pages/login/login-banner-ds.webp"
          [fill]="true"
        />
      </picture>
    </div>
  </section>

  <app-newsletter-section />
</div>
